import * as React from 'react';
import { JRCAppHeaderProps } from './JRCAppHeader.types';
import { JRCIcon } from '../JRCIcon/JRCIcon';
import { JRCTypography } from '../JRCTypography/JRCTypography';
import { FormattedMessage } from 'react-intl';
import { HeaderContainer } from './JRCAppHeader.styles';
import { WrapperTop } from './JRCAppHeader.styles';

const defaultProps = {};

const JRCAppHeader = (props: JRCAppHeaderProps) => {
    return (
        <HeaderContainer>
            <WrapperTop>
                <JRCIcon name={props.icon} variant="circle" color={props.color} size={40} />
                <JRCTypography variant="h1" size="xl" weight="medium">
                    <FormattedMessage id={props.title} />
                </JRCTypography>
            </WrapperTop>
            <FormattedMessage id={props.description} />
        </HeaderContainer>
    );
};

JRCAppHeader.defaultProps = defaultProps;
export { JRCAppHeader };
